
<p-toolbar>
	<ng-template pTemplate="left">
		<div class="grid formgrid fluid w-full">

			<!-- Bouton exporter -->
			<div>
				<button
					type="button"
					pButton
					icon="pi pi-download"
					[label]="'common.export_action_label' | translate"
					(click)="exporterHistorique()"
					[loading]="exportLoading"
				></button>
			</div>

			<!-- Sélecteur de site -->
			<div *ngIf="sit_ids.length != 1" class="field col-fixed">
				<site-selector
					name="destination_sit_id"
					[abo_id]="abo_id"
					[(ngModel)]="sit_id"
					(ngModelChange)="refresh()"
					[nullOption]="true"
				/>
			</div>
		</div>
	</ng-template>
</p-toolbar>

<p-table
	#tableHistorique
	[value]="values"
	[lazy]="true"
	(onLazyLoad)="loadHistorique($event)"
	[loading]="loading"
	[paginator]="true"
	[rows]="rows"
	[showCurrentPageReport]="true"
	[totalRecords]="totalRecords"
	currentPageReportTemplate="{{totalRecords | number}} {{'common.table_total_records'|translate}}"
	paginatorDropdownAppendTo="body"
	[rowsPerPageOptions]="[10,25,50]"
	styleClass="p-datatable-sm p-datatable-gridlines table-scrollable-hover"
	[autoLayout]="true"
	responsiveLayout="scroll"
	scrollDirection="both"
	[scrollable]="true"
	scrollHeight="flex"
>
	<!-- Header -->
	<ng-template pTemplate="header">
		<tr>
			<th *ngIf="!isMonoSite" class="text-center">
				{{ 'sites.site_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'common.modification_date_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'recolements.status_short' | translate }}
			</th>

			<th *ngIf="etapeConformite == 'evaluations'" class="text-center">
				{{ 'recolements.evaluation_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'common.modifier_label' | translate }}
			</th>
		</tr>
	</ng-template>

	<ng-template pTemplate="body" let-hist>
		<tr>
			<td *ngIf="!isMonoSite" class="font-bold">{{hist.sit_libelle}}</td>

			<td>{{hist.ctx_date	| date:'short'}}</td>

			<td class="text-center">{{hist.sta_libelle}}</td>

			<td *ngIf="etapeConformite == 'evaluations'" class="text-center">
				{{hist.eva_libelle}}
			</td>

			<td>{{hist | utilisateur:true}}</td>
		</tr>
	</ng-template>

</p-table>
